import {
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  collection,
  query,
  where,
  Timestamp
} from 'firebase/firestore';
import { onSnapshotWithRetry as onSnapshot } from '../utils/firestoreSubscribe';
import { getDb } from '../firebase';

export const createRule = async (familyId, ruleData) => {
  const db = getDb();
  const ref = doc(collection(db, 'families', familyId, 'householdRules'));
  const data = {
    ...ruleData,
    status: 'proposed',
    respondedBy: null,
    respondedAt: null,
    isActive: true,
    createdAt: Timestamp.now()
  };
  await setDoc(ref, data);
  return { id: ref.id, ...data };
};

export const updateRule = async (familyId, ruleId, updates) => {
  const db = getDb();
  await updateDoc(doc(db, 'families', familyId, 'householdRules', ruleId), {
    ...updates,
    status: 'proposed',
    respondedBy: null,
    respondedAt: null
  });
};

export const deleteRule = async (familyId, ruleId) => {
  const db = getDb();
  await deleteDoc(doc(db, 'families', familyId, 'householdRules', ruleId));
};

export const respondToRule = async (familyId, ruleId, status, respondedBy) => {
  const db = getDb();
  await updateDoc(doc(db, 'families', familyId, 'householdRules', ruleId), {
    status,
    respondedBy,
    respondedAt: Timestamp.now()
  });
};

export const subscribeToRules = (familyId, callback) => {
  const db = getDb();
  const q = query(
    collection(db, 'families', familyId, 'householdRules'),
    where('isActive', '==', true)
  );
  return onSnapshot(q, (snapshot) => {
    const rules = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    callback(rules);
  }, (error) => {
    console.error('Household rules listener error:', error);
  });
};
